import React from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useLoginBackground } from 'hooks/useLoginBackground'
import Layout from '../components/Layout'
import Header from '../components/Cognito/Shared/Header'
import Footer from '../components/Cognito/Shared/Footer'
import LoginForm from '../components/Cognito/LoginForm'
import Skeleton from '../components/Shared/Skeleton'

/**
 * It displays form to reset the recovery the password.
 * @Tags( page, layout, unlogged-users )
 * @SuggestedTags( cognito )
 * @Routes( /login )
 */
const Login = () => {
  const { t } = useTranslation()

  const bgImage = useLoginBackground()

  return (
    <Layout title={t('Login.PageTitle')}>
      <Helmet bodyAttributes={{ class: 'authentication-page login-page' }} />
      <div className="login-page-wrapper">
        <Header backTo="/" />
        <main className="login-form mb-0" data-cy="login-form-cy">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg">
                <div className="login-content">
                  <LoginForm />
                  <Footer />
                </div>
              </div>
              <div
                className="col-lg-auto d-none d-lg-block px-lg-0 image-col"
                style={{ 
                  backgroundImage: `url('${bgImage.loading ? '' : bgImage.url}')`,
                  backgroundSize: 'cover', 
                  backgroundPosition: 'center',  
                  backgroundColor: '#e9ecef'

                }}
              >
                <Skeleton isLoading={bgImage.loading} />
              </div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default Login
